<template>
  <div class="main">
    <div class="main_header">
      <div class="header_item">

      </div>
      <div class="header_item">
      <el-button icon="el-icon-search">查询</el-button>
      <el-button class="search_btn" icon="el-icon-plus" >新增</el-button>
      <el-button icon="el-icon-download">导出Excel</el-button>
      </div>
    </div>
    <div class="main_content">

    </div>
    <div class="main_footer">

    </div>
  </div>
</template>

<script>
import { buttonPinia } from '../../pinia';
import { changeSize } from '../../plugins/public'
  export default {
    data() {
      return {
        size: changeSize(),
        total: 0,
        pageNum: 1,
        pageSize: 10,
        loading: false,
      }
    },
    mounted() {
      const that = this;
      // 根据窗口大小动态修改组件尺寸
      window.onresize = () => {
        that.size = changeSize();
      }
    },
    methods: {
      // 切换页码
      changePageNum(page) {
        this.pageNum = page;
        this.searchConsigneeList();
      },
      // 切换每页条数
      changePageSize(size) {
        this.pageSize = size;
        this.searchConsigneeList();
      },
      // 判断按钮权限信息
      showButton(str) {
        const pinia = buttonPinia();
        return pinia.$state.buttonInfo.includes(str);
      }
    },
    watch: {

    }
  }
</script>

<style lang="scss" scoped>
@import '../../style/layout-main.scss';
</style>